export type WebBranding = {
  appName: string;
  shortName: string;
  description: string;
  primaryColor: string;
  logoUrl: string;
  pdfLogoUrl: string;
  secondaryLogoUrl: string;
  faviconUrl: string;
};

const envValue = (key: string, fallback: string) => {
  const raw = process.env[key];
  return typeof raw === "string" && raw.trim() ? raw.trim() : fallback;
};

const publicUrl = process.env.PUBLIC_URL || "";

const withPublicUrl = (path: string) => {
  if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) return path;
  return `${publicUrl}${path.startsWith("/") ? path : `/${path}`}`;
};

export const branding: WebBranding = {
  appName: envValue("REACT_APP_BRAND_APP_NAME", "B2Meet"),
  shortName: envValue("REACT_APP_BRAND_SHORT_NAME", "B2Meet"),
  description: envValue("REACT_APP_BRAND_DESCRIPTION", "B2Meet resmi web uygulaması"),
  primaryColor: envValue("REACT_APP_BRAND_PRIMARY_COLOR", "#3b82f6"),
  logoUrl: withPublicUrl(envValue("REACT_APP_BRAND_LOGO_URL", "/branding/b2meet-logo-horizontal.png")),
  pdfLogoUrl: withPublicUrl(envValue("REACT_APP_BRAND_PDF_LOGO_URL", "/branding/b2meet-logo-horizontal.png")),
  secondaryLogoUrl: withPublicUrl(envValue("REACT_APP_BRAND_SECONDARY_LOGO_URL", "/branding/b2meet-logo-square.png")),
  faviconUrl: withPublicUrl(envValue("REACT_APP_BRAND_FAVICON_URL", "/branding/b2meet-icon.png")),
};

export function applyBrandingToDocument() {
  if (typeof document === "undefined") return;
  document.title = branding.appName;
  document.documentElement.style.setProperty("--brand-primary", branding.primaryColor);

  let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }
  favicon.href = branding.faviconUrl;
}
